import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getTripsAverageSpeedByDriverId } from '../../services/TripsService';
import { TripsAverageSpeedResponse } from '../../types/Trips';

function useGetTripsAverageSpeedByDriverId(fleetId: string, driverId: string): UseQueryResult<TripsAverageSpeedResponse> {
  return useQuery(
    ['trips-aggregation-avgSpeedMs', fleetId, driverId],
    async (): Promise<TripsAverageSpeedResponse> => getTripsAverageSpeedByDriverId(fleetId, driverId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetTripsAverageSpeedByDriverId;
